import { render } from "./Boot.vue?vue&type=template&id=b6c5fc82"
import script from "./Boot.vue?vue&type=script&lang=js"
export * from "./Boot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__